@if (pomt?.length > 0) {
<div>
    @for( p of pomt; track p) {
    <div class="goal-container">
        <div class="float outcome-metrics charts goal-column-metrics">
            <div class="position-left">
                <div class="metric-overflow">{{p?.outcomeMetricName}}</div>
                <div class="metric-value">
                    <span>{{(getOutcomeMetricProgress(p.outcomeMetricId)| number:'1.0-0')}}</span>
                    <span class="bold">/{{(p?.targetValue | number:'1.0-0')}} {{displayPreferredOutcomeMetricName()}}</span>
                </div>
            </div>
            <div class="bar completed-progress-bar" [style.width.%]="outcomeMetricPercentageCalculator(p.outcomeMetricId)"></div>
            <div class="bar remainder-progress-bar" [style.width.%]="outcomeMetricRemainderPercentageCalculator(p.outcomeMetricId)"></div>
        </div>
        <div class="percentage-spacing" [ngClass]="getGoalClass(goal.name)">
            {{ (outcomeMetricPercentageCalculator(p.outcomeMetricId)| number:'1.0-0') + '%'}}
        </div>
    </div>
    }
</div>
}
